import PropTypes from "prop-types";
import "./Btn.css";

export default function Btn({ className, label, onClick, icon, icon2 }) {
	return (
		<button
			type="button"
			className={`standard-btn ${className || ""}`}
			onClick={onClick}
		>
			{icon}
			{label}
			{icon2}
		</button>
	);
}

Btn.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	icon: PropTypes.element,
	icon2: PropTypes.element,
};
